import React from 'react'
import { Navigate } from 'react-router-dom'

export const NoRouteFound = () => {
    localStorage.clear();
  return <Navigate to={"/login"} />
}

